import React from 'react'
import { hasAuth } from 'meinian-package/src/utils/auth'
import qs from 'qs'
import UploadIns from 'meinian-package/src/component/uploadIns'
import mes from 'meinian-package/src/utils/message'
import './emptySubTitle.less'

export default () => {
  const query = qs.parse(location.search, { ignoreQueryPrefix: true })
  return <span className="mn-empty-sub-title">
    去&nbsp;
    <a href="/home">知衣</a>
    &nbsp;
    <a href={hasAuth('dl_ins') ? '/df' : '/afflatus'}>知款</a>
    &nbsp;
    <a href="/douyin">抖衣</a>
    &nbsp;
    <a href="/cross-border/monitoring/site/new-goods">海外探款</a>
    &nbsp;
    采集款式，也可以&nbsp;
    <a onClick={() => {
      UploadIns.Show({
        inspirationId: query.inspirationId ? Number(query.inspirationId) : null,
        callback: () => {
          mes.pub('onMNUploadImage')
          mes.pub('onMNCreateIns')
        }
      })
    }}
    >上传款式</a>
  </span>
}
